document.addEventListener("DOMContentLoaded", initCustomModal);

function initCustomModal() {
    setupModalWidget();
    setupModalCloseHandlers();
}

function setupModalWidget() {
    const customModal = document.querySelector(".boa-popup-modal");

    if (!customModal) {
        return;
    }

    const modalCloseBtn = customModal.querySelector(".modal-close-btn");

    modalCloseBtn?.addEventListener("click", () => {
        customModal.classList.remove("show");
        document.body.style.overflow = '';
    });
}

function setupModalCloseHandlers() {
    const customModal = document.querySelector(".boa-popup-modal");  
    customModal.addEventListener("click", (e) => {
        if (e.target === customModal) {
            customModal.classList.add('modal-static');
            setTimeout(() => {
                customModal.classList.remove('modal-static');
            }, 100)
        }
    });
}